/* Landing de pauta · Pantaloneta Olas · Libardino.
   Galería que se desliza, talla y pack que fijan el formulario, «arma tu pack» (pantaloneta 2 y 3 con su color y
   su talla; con 2 o 3 se listan TODAS y la talla suelta se oculta), COMPRAR AHORA (enlace de carrito con todas las
   unidades → checkout de Shopify, pago en línea con Bold), Agregar al carrito, valoración bajo el precio (de las
   reseñas cargadas), barra fija, guía de tallas en ventana y fechas. Sin librerías
   ni apps. */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const dinero = (c) => "$" + Math.round(Number(c) / 100).toLocaleString("es-CO");
  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const pixel = (ev, info) => { try { if (typeof window.fbq === "function") window.fbq("track", ev, info || {}); } catch (e) {} };
  const reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Galería ─────────────────────────────────────────────────── */
  function galeria() {
    $$("[data-olas-galeria]").forEach((g) => {
      const pista = $(".olas-galeria__pista", g);
      const items = $$(".olas-galeria__item", g);
      const n = $("[data-olas-galeria-n]", g);
      const puntos = $$("[data-olas-puntos] button", g);
      if (!pista || items.length < 2) return;
      const actual = () => Math.round(pista.scrollLeft / pista.clientWidth);
      const pintar = () => {
        const i = actual();
        if (n) n.textContent = String(i + 1);
        puntos.forEach((p, k) => (k === i ? p.setAttribute("aria-current", "true") : p.removeAttribute("aria-current")));
      };
      let t;
      pista.addEventListener("scroll", () => { clearTimeout(t); t = setTimeout(pintar, 60); }, { passive: true });
      puntos.forEach((p) => p.addEventListener("click", () => pista.scrollTo({ left: Number(p.dataset.ir) * pista.clientWidth, behavior: reducido ? "auto" : "smooth" })));
      pista.addEventListener("keydown", (e) => {
        const paso = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
        if (!paso) return;
        e.preventDefault();
        pista.scrollTo({ left: Math.min(items.length - 1, Math.max(0, actual() + paso)) * pista.clientWidth, behavior: reducido ? "auto" : "smooth" });
      });
      pintar();
    });
    // Videos: se cargan y arrancan solo cuando se ven (mudos); el botón activa el sonido
    const videos = $$("[data-olas-video]");
    if (videos.length && "IntersectionObserver" in window) {
      const io = new IntersectionObserver((ents) => ents.forEach((en) => {
        const v = en.target;
        if (en.intersectionRatio >= 0.5) {
          if (v.dataset.src) { v.src = v.dataset.src; v.removeAttribute("data-src"); }
          v.play().catch(() => {});
        } else if (!v.paused) v.pause();
      }), { threshold: [0, 0.5, 1] });
      videos.forEach((v) => io.observe(v));
    }
    $$("[data-olas-sonido]").forEach((b) => b.addEventListener("click", () => {
      const v = $("video", b.parentElement);
      if (!v) return;
      const con = v.muted;
      v.muted = !con;
      b.setAttribute("aria-pressed", String(con));
      b.querySelector("span").textContent = con ? "Sin sonido" : "Con sonido";
      if (con) { if (v.dataset.src) { v.src = v.dataset.src; v.removeAttribute("data-src"); } v.currentTime = 0; v.play().catch(() => {}); }
    }));
  }

  /* ── Ficha: talla, pack, arma tu pack, precio, compra ────────── */
  function ficha() {
    const f = $("[data-olas-ficha]");
    if (!f) return;
    const form = $("[data-olas-form]", f);
    const idVar = $("[data-olas-variante]", form);
    const cant = $("[data-olas-cantidad]", form);
    const unidad = Number(f.dataset.unidad);
    const packs = { 1: unidad, 2: Number(f.dataset.pack2), 3: Number(f.dataset.pack3) };
    const tallas = $$("input[name='olas-talla']", form);
    const radiosPack = $$("input[name='olas-pack']", form);
    const quedan = $("[data-olas-quedan]", f);
    const errorTalla = $("[data-olas-error-talla]", f);
    const campoTallas = $("[data-olas-tallas]", f);
    const aviso = $("[data-olas-aviso]", f);
    const unidades = $("[data-olas-unidades]", f);
    const filas = $$("[data-olas-unidad]", f);
    const handle = f.dataset.handle;
    const fila1 = filas.find((x) => x.dataset.olasUnidad === "1") || null;

    const tallaElegida = () => tallas.find((t) => t.checked) || null;
    // Resumen vivo en el título de cada fila del pack: «Pantaloneta 2 · Verde · M»
    const selColor = (fila) => $("select[name$='-color']", fila);
    const selTalla = (fila) => { const g = $$("[data-olas-tallas-de]", fila).find((x) => !x.hidden); return g ? $("select", g) : null; };
    const textoElegido = (s) => (s && s.value && s.selectedOptions[0] ? s.selectedOptions[0].textContent.trim() : "");
    const resumir = (fila) => {
      const r = $("[data-olas-resumen]", fila);
      if (!r) return;
      r.textContent = [textoElegido(selColor(fila)), textoElegido(selTalla(fila))].filter(Boolean).map((x) => ` · ${x}`).join("");
    };
    const limpiarFila = (fila) => { fila.classList.remove("olas-unidad--error"); const e = $("[data-olas-error-unidad]", fila); if (e) e.hidden = true; };
    const cantidad = () => Number(cant.value) || 1;

    const pintarPrecio = () => {
      const n = cantidad();
      const total = packs[n] > 0 ? packs[n] : unidad * n;
      const suma = unidad * n;
      const ahorro = suma - total;
      $$("[data-olas-precio]", f).forEach((e) => (e.textContent = dinero(total)));
      $$("[data-olas-barra-precio]", f).forEach((e) => (e.textContent = dinero(total)));
      $$("[data-olas-barra-sub]", f).forEach((e) => (e.textContent = n > 1 ? `${n} pantalonetas · pago seguro en línea` : "Pago seguro en línea"));
      const pct = $("[data-olas-pct]", f), antes = $("[data-olas-antes]", f), ah = $("[data-olas-ahorro]", f), un = $("[data-olas-precio-unidad]", f);
      const con = n > 1 && ahorro > 0;
      if (pct) { pct.hidden = !con; pct.textContent = con ? `-${Math.round((ahorro * 100) / suma)} %` : ""; }
      if (antes) { antes.hidden = !con; antes.innerHTML = con ? `${n} sueltas: <s>${dinero(suma)}</s>` : ""; }
      if (ah) { ah.hidden = !con; ah.textContent = con ? `Ahorras ${dinero(ahorro)}` : ""; }
      if (un) { un.hidden = n < 2; un.textContent = n > 1 ? `${dinero(Math.round(total / n))} cada una · mezcla colores y tallas` : ""; }
    };
    // «Arma tu pack»: con 2 o 3 pantalonetas se listan TODAS (1, 2 y 3) con su color y su talla, y la talla suelta
    // de arriba se oculta (la Pantaloneta 1 la reemplaza; van sincronizadas). Con 1 sola, al revés.
    const pintarUnidades = () => {
      const n = cantidad();
      if (unidades) unidades.hidden = n < 2;
      filas.forEach((fila) => (fila.hidden = n < 2 || Number(fila.dataset.olasUnidad) > n));
      if (campoTallas) campoTallas.hidden = n >= 2;
      filas.forEach(resumir);
    };
    const fijarPack = (n) => {
      cant.value = String(n);
      radiosPack.forEach((r) => (r.checked = Number(r.value) === n));
      pintarPrecio();
      pintarUnidades();
    };
    const fijarTalla = (t) => {
      idVar.value = t.value;
      if (quedan) {
        const q = Number(t.dataset.quedan);
        quedan.hidden = !(q > 0);
        quedan.textContent = q > 0 ? `Quedan ${q} en talla ${t.dataset.titulo}` : "";
      }
      errorTalla.hidden = true;
      campoTallas.classList.remove("olas-campo--error");
      // La Pantaloneta 1 del pack (en el color de esta página) lleva la misma talla
      if (fila1) {
        const s = $(`[data-olas-tallas-de='${handle}'] select`, fila1);
        if (s && s.value !== t.value) s.value = t.value;
        if (s) limpiarFila(fila1);
        resumir(fila1);
      }
    };
    tallas.forEach((t) => t.addEventListener("change", () => fijarTalla(t)));
    radiosPack.forEach((r) => r.addEventListener("change", () => fijarPack(Number(r.value))));
    $$("[data-olas-elegir-pack]").forEach((b) => b.addEventListener("click", () => {
      fijarPack(Number(b.dataset.olasElegirPack));
      $("#comprar").scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "start" });
    }));
    // En cada fila, el color elegido muestra las tallas de ESE color
    filas.forEach((fila) => {
      const grupos = $$("[data-olas-tallas-de]", fila);
      const mostrar = (handle) => grupos.forEach((g) => (g.hidden = g.dataset.olasTallasDe !== handle));
      const c = selColor(fila);
      if (c) c.addEventListener("change", () => { mostrar(c.value); limpiarFila(fila); resumir(fila); });
      $$("select[name*='-talla-']", fila).forEach((t) => t.addEventListener("change", () => {
        limpiarFila(fila);
        resumir(fila);
        // La talla de la Pantaloneta 1 en el color de esta página ES la talla principal (misma variante)
        if (fila === fila1 && t.value && t.name.endsWith(`-talla-${handle}`)) { const m = tallas.find((x) => x.value === t.value); if (m && !m.checked) { m.checked = true; fijarTalla(m); } }
      }));
    });
    const inicial = tallaElegida();
    if (inicial) fijarTalla(inicial);
    pintarPrecio();
    pintarUnidades();

    // Qué se compra: [{id, quantity}] con las unidades juntas por variante, o null si falta una talla.
    // Con 1 pantaloneta manda la talla suelta; con 2 o 3, las filas de «Arma tu pack» (todas visibles).
    const seleccion = () => {
      let falta = null;
      const items = [];
      if (cantidad() < 2) {
        const t1 = tallaElegida();
        if (!t1) {
          errorTalla.hidden = false;
          campoTallas.classList.add("olas-campo--error");
          falta = campoTallas;
        } else items.push(Number(t1.value));
      }
      filas.filter((fila) => !fila.hidden).forEach((fila) => {
        const t = selTalla(fila);
        if (!t || !t.value) {
          fila.classList.add("olas-unidad--error");
          $("[data-olas-error-unidad]", fila).hidden = false;
          falta = falta || fila;
        } else items.push(Number(t.value));
      });
      if (falta) {
        falta.scrollIntoView({ behavior: reducido ? "auto" : "smooth", block: "center" });
        return null;
      }
      const juntos = [];
      items.forEach((id) => { const l = juntos.find((x) => x.id === id); if (l) l.quantity++; else juntos.push({ id, quantity: 1 }); });
      return juntos;
    };
    const mostrar = (txt, html, error) => {
      if (!aviso) return;
      aviso.hidden = false;
      aviso.classList.toggle("olas-aviso--error", !!error);
      if (html) aviso.innerHTML = html; else aviso.textContent = txt;
    };
    const total = () => { const n = cantidad(); return (packs[n] > 0 ? packs[n] : unidad * n) / 100; };
    const agregarAlCarrito = async (items) => {
      const r = await fetch(`${raiz}cart/add.js`, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
      if (!r.ok) throw new Error((await r.json()).description || "No se pudo agregar");
      const c = await (await fetch(`${raiz}cart.js`)).json();
      $$("[data-olas-cuenta]").forEach((e) => { e.textContent = String(c.item_count); e.hidden = c.item_count === 0; });
      return c;
    };

    // COMPRAR AHORA: enlace de carrito de Shopify con todas las unidades del pack
    // (/cart/variante:cantidad,variante:cantidad) que lleva derecho al checkout; allí el comprador paga en línea
    // con Bold (tarjeta, PSE, Bre-B, Nequi, Bancolombia…). Sin apps.
    const comprar = (boton) => {
      const items = seleccion();
      if (!items) return;
      const n = cantidad();
      pixel("InitiateCheckout", { value: total(), currency: "COP", num_items: n });
      boton.disabled = true;
      window.location.href = `${raiz}cart/${items.map((i) => `${i.id}:${i.quantity}`).join(",")}`;
    };
    $$("[data-olas-comprar]").forEach((b) => b.addEventListener("click", () => comprar(b)));

    // Agregar al carrito: todo el pack tal como está armado
    const agregar = async (boton) => {
      const items = seleccion();
      if (!items) return;
      const n = cantidad();
      boton.disabled = true;
      try {
        await agregarAlCarrito(items);
        pixel("AddToCart", { value: total(), currency: "COP", num_items: n });
        mostrar("", `Listo, ${n > 1 ? n + " pantalonetas agregadas" : "agregada al carrito"}. <a href="${raiz}cart">Ver carrito y pagar</a> o sigue armando otro pack.`);
      } catch (e) {
        mostrar(e.message || "No se pudo agregar. Intenta de nuevo.", "", true);
      }
      boton.disabled = false;
    };
    $$("[data-olas-agregar]").forEach((b) => b.addEventListener("click", () => agregar(b)));

    // Valoración bajo el título (estilo TikTok Shop): sale SOLO si hay reseñas cargadas en la sección de reseñas
    const val = $("[data-olas-valoracion]", f);
    const resumen = $("#resenas .olas-resumen-resenas");
    if (val && resumen) {
      const n = $$("#resenas .olas-resena").length;
      const txt = (resumen.querySelector(".olas-resumen-resenas__detalle span:last-child") || resumen).textContent.trim();
      const estrellas = resumen.querySelector(".olas-estrellas");
      if (n > 0 && txt) { val.innerHTML = `<span class="olas-estrellas" aria-hidden="true">${estrellas ? estrellas.innerHTML : ""}</span><span>${txt}</span>`; val.hidden = false; }
    }

    pixel("ViewContent", { content_ids: [f.dataset.productoId], content_type: "product", value: unidad / 100, currency: "COP" });
  }

  /* ── Barra fija: aparece cuando el botón del héroe ya pasó ───── */
  function barra() {
    const b = $("[data-olas-barra]");
    const ancla = $("#comprar .olas-botones");
    if (!b || !ancla) return;
    const revisar = () => {
      const r = ancla.getBoundingClientRect();
      const si = r.bottom < 0;
      b.hidden = !si;
      if (si) b.removeAttribute("inert"); else b.setAttribute("inert", "");
    };
    revisar();
    window.addEventListener("scroll", revisar, { passive: true });
    window.addEventListener("resize", revisar);
  }

  /* ── Reseñas: «Ver todas» muestra las que quedaron ocultas ────── */
  function resenas() {
    const lista = $("[data-olas-resenas]");
    const boton = $("[data-olas-resenas-mas]");
    if (!lista || !boton) return;
    boton.addEventListener("click", () => { lista.classList.add("olas-resenas--todas"); boton.hidden = true; });
  }

  /* ── Guía de tallas en ventana ───────────────────────────────── */
  function modalTallas() {
    const m = $("[data-olas-modal-tallas]");
    if (!m) return;
    const caja = $(".olas-modal__caja", m);
    let disparador = null;
    const abrir = (b) => { disparador = b; m.hidden = false; document.body.classList.add("olas-sin-scroll"); caja.focus(); };
    const cerrar = () => { m.hidden = true; document.body.classList.remove("olas-sin-scroll"); disparador?.focus(); };
    $$("[data-olas-abrir-tallas]").forEach((b) => b.addEventListener("click", () => abrir(b)));
    $$("[data-olas-cerrar-tallas]", m).forEach((b) => b.addEventListener("click", cerrar));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !m.hidden) cerrar(); });
  }

  /* ── Fechas de entrega (días hábiles desde hoy) ──────────────── */
  function fechas() {
    const habiles = (desde, n) => { const d = new Date(desde); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) k++; } return d; };
    const fmt = (d) => d.toLocaleDateString("es-CO", { weekday: "long", day: "numeric", month: "long" });
    const hoy = new Date();
    $$("[data-olas-fecha]").forEach((e) => {
      const [a, b] = e.dataset.olasFecha.split("-").map(Number);
      e.textContent = b ? `entre el ${fmt(habiles(hoy, a))} y el ${fmt(habiles(hoy, b))}` : fmt(habiles(hoy, a));
    });
  }

  document.addEventListener("DOMContentLoaded", () => { galeria(); ficha(); resenas(); barra(); modalTallas(); fechas(); });
})();
